var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.999,
    height: 17,
    viewBox: "0 0 16.999 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "update",
    d: "M21.5,11.224H15.1l2.588-2.663a6.648,6.648,0,0,0-9.331-.094,6.493,6.493,0,0,0,0,9.246,6.63,6.63,0,0,0,9.331,0,6.151,6.151,0,0,0,1.927-4.618H21.5a8.822,8.822,0,0,1-2.493,5.941,8.551,8.551,0,0,1-12.013,0A8.349,8.349,0,0,1,6.975,7.154a8.488,8.488,0,0,1,11.947,0L21.5,4.5Zm-8.028-2v4.014L16.778,15.2l-.68,1.143-4.042-2.4V9.222Z",
    transform: "translate(-4.502 -4.5)",
    fill: "#33d1eb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.94472bad60f40acd617c624fbf6daad8.svg";
export { ForwardRef as ReactComponent };